const routerKeys = {
    TEST: 'TEST',
    NOT_FOUND: 'Not_Found',
    BLANK: 'Loading',
    // Welcome Stack
    WELCOME: 'Welcome',
    LOGIN: 'Login',
    REGISTER: 'Register',
    FORGOT_PASSWORD: 'ForgotPassword',
    // MAIN STACK
    MAIN: 'Main',
    // Profile Tab
    PROFILE_STACK: 'ProfileStack',
    PROFILE: 'Profile',
    PROFILE_EDIT: 'ProfileEdit',
    PROFILE_EDIT_PHOTOS: 'ProfileEditPhotos',
    REVIEWS: 'Reviews',
    REVIEW_DETAILS: 'ReviewDetails',
    MENU: 'Menu',
    MENU_ITEM_DETAILS: 'MenuItemDetails',
    PROFILE_SCHEDULE: 'Schedule',
    PROFILE_SCHEDULE_EDIT: 'ScheduleEdit',
    // Dashboard Tab
    DASHBOARD_STACK: 'DashboardStack',
    DASHBOARD: 'Dashboard',
    // Orders Tab
    ORDER_STACK: 'OrderStack',
    ORDERS: 'Orders',
    // Catering Tab
    CATERING_STACK: 'CastingStack',
    CATERING: 'Catering',
    CATERING_DETAILS: 'CateringDetails',
    CATERING_DETAILS_PROPOSAL: 'CateringDetailsProposal',
    CATERING_PAST: 'CateringPast',
    CATERING_EXTERNAL_LEAD: 'CateringExternalLead',
    HOOD: 'Hood',
    HOOD_DETAILS: 'CateringHoodDetails',
    HOOD_PAST: 'HoodPast',
    // Chat Tab
    CHAT_STACK: 'ChatStack',
    CHAT: 'Chat',
    CHAT_NEW: 'ChatNewTopic',
    CHAT_DETAILS: 'ChatDetails',
    // Resources Tab
    RESOURCES_STACK: 'ResourcesStack',
    RESOURCES: 'Resources',
    RESOURCE_DETAILS: 'ResourceDetails',
    // Settings Tab
    MORE_STACK: 'MoreStack',
    MORE: 'More',
    // Account Settings
    ACCOUNT_SETTINGS_STACK: 'AccountSettingsStack',
    ACCOUNT_SETTINGS: 'AccountSettings',
    SUBSCRIPTION_TIERS: 'SubscriptionTiers'
};

export default routerKeys;
